module.exports = {
  src: __webpack_public_path__ + "static/media/glyphicons-map-marker.a39a59e2.png",
  width: 19,
  height: 25,
  bytes: 1416,
  type: "png",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/glyphicons-map-marker.a39a59e2.png";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/components/GetInTouch/icons/glyphicons-map-marker.png
// module id = 138
// module chunks = 0